import { addMonths, addWeeks, addYears, startOfDay } from 'date-fns';
import type { RecurringFrequency } from '@/lib/constants/recurring';

export function advanceRecurringDate(
  date: Date,
  frequency: RecurringFrequency
): Date {
  const d = startOfDay(date);
  switch (frequency) {
    case 'WEEKLY':
      return addWeeks(d, 1);
    case 'MONTHLY':
      return addMonths(d, 1);
    case 'QUARTERLY':
      return addMonths(d, 3);
    case 'ANNUALLY':
      return addYears(d, 1);
    default:
      return addMonths(d, 1);
  }
}
